import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, Bell, Menu, UserCircle, Settings, LogOut } from 'lucide-react';
import { useUser } from '../../context/UserContext';

const AdminNavbar = ({ onToggleMobile }) => {
  const navigate = useNavigate();
  const { user, logout } = useUser();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <header className="admin-header">
      <div className="d-flex align-items-center gap-3">
        <button className="btn-icon mobile-toggle" onClick={onToggleMobile}>
          <Menu size={20} />
        </button>
        <div className="d-none d-md-block">
          <h5 className="mb-0 fw-bold" style={{ color: 'var(--admin-text-primary)' }}>
            Welcome back, {user?.name?.split(' ')[0] || 'Admin'} 👋
          </h5>
        </div>
      </div>

      <div className="header-actions">
        <div className="header-search d-none d-lg-block">
          <Search size={16} />
          <input type="text" placeholder="Search across dashboard..." />
        </div>

        <button className="btn-icon position-relative">
          <Bell size={20} />
          <span className="position-absolute top-0 end-0 translate-middle p-1 bg-danger border border-2 border-white rounded-circle" style={{ marginTop: '8px', marginRight: '8px' }}></span>
        </button>

        <div className="dropdown">
          <button className="profile-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
            <img 
              src={`https://ui-avatars.com/api/?name=${user?.name || 'Admin'}&background=2563eb&color=fff&bold=true`} 
              alt="avatar" 
              className="profile-avatar"
            />
            <div className="profile-info">
              <span className="profile-name">{user?.name || 'Admin User'}</span>
              <span className="profile-role">Super Admin</span>
            </div>
          </button>
          <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3 mt-2" style={{ minWidth: '200px' }}>
            <li>
              <Link className="dropdown-item py-2 d-flex align-items-center gap-2 px-3" to="/admin/profile">
                <UserCircle size={16} className="text-muted" /> <span style={{fontSize: '0.875rem', fontWeight: 500}}>My Profile</span>
              </Link>
            </li>
            <li>
              <Link className="dropdown-item py-2 d-flex align-items-center gap-2 px-3" to="/admin/settings">
                <Settings size={16} className="text-muted" /> <span style={{fontSize: '0.875rem', fontWeight: 500}}>Settings</span>
              </Link>
            </li>
            <li><hr className="dropdown-divider my-1" /></li>
            <li>
              <button onClick={handleLogout} className="dropdown-item py-2 text-danger d-flex align-items-center gap-2 px-3 bg-transparent border-0">
                <LogOut size={16} /> <span style={{fontSize: '0.875rem', fontWeight: 500}}>Sign Out</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default AdminNavbar;